import { format } from 'date-fns';
import React from 'react';
import ChartWrapper from 'src/frontend-common/components/Charts/Wrapper';
import { useGetCompaniesQuery } from 'src/redux/services/adminDashboard';
import { shortTextFormat } from 'src/utils/date';

interface Props {
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
}

const LatestSignups: React.FC<Props> = ({ dateRange }) => {
  const {
    data: companiesData,
    isLoading: isLoadingCompanies,
    isFetching: isFetchingCompanies,
  } = useGetCompaniesQuery({
    start_date: format(dateRange.startDate, "yyyy-MM-dd'T'HH:mm:ss.SSS") + 'UTC',
    end_date: format(dateRange.endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS") + 'UTC',
  });

  const dateFormatter = (s: string): string => {
    const date = new Date(s);
    return shortTextFormat(date).toString();
  };

  return (
    <ChartWrapper
      key={'latest-companies'}
      isLoading={isLoadingCompanies || isFetchingCompanies}
      components={[
        {
          chart: {
            cartesianGrid: { horizontalLines: true, verticalLines: true },
            data: Object.entries(companiesData?.values || []).map(([date, value]) => ({
              values: {
                signups: value,
              },
              xAxisLabel: dateFormatter(date),
            })),

            height: 500,
            stackedBars: false,
            type: 'barChart',
          },
          isEmpty: Object.entries(companiesData?.values || []).every(([, value]) => value === 0),
          tabLabel: '',
          title: 'Latest Signups',
        },
      ]}
    />
  );
};

export default React.memo(LatestSignups);
